import { ColumnDef } from '@tanstack/react-table';
import { Button } from '@/components/ui/button';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import type { Location } from 'src/trpc';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export const LocationColumns: ColumnDef<Location>[] = [
  {
    accessorKey: 'name',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Name
          {!column.getIsSorted() && <ArrowUpDown className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'asc' && <ArrowUp className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'desc' && <ArrowDown className="ml-2 h-4 w-4" />}
        </Button>
      );
    },
    cell: ({ cell }) => {
      const value = cell.getValue() as string;
      return (
        <div className="w-fit">
          <span className="font-medium">{value}</span>
        </div>
      );
    },
  },

  {
    accessorKey: 'address.city',
    header: 'City',
    cell: ({ row }) => {
      const city = row.original.address.city;
      const state = row.original.address.state;
      const postalCode = row.original.address.postalCode;
      const address = row.original.address.line1;
      const line2 = row.original.address.line2;
      return (
        <div className="w-fit">
          <p className="text-text-primary">{address}</p>
          {line2 && <p className="text-text-primary">{line2}</p>}
          <p className="text-text-primary">{city + ' ' + state + ' ' + postalCode}</p>
        </div>
      );
    },
  },
  {
    accessorKey: 'isActive',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Status
          {!column.getIsSorted() && <ArrowUpDown className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'asc' && <ArrowUp className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'desc' && <ArrowDown className="ml-2 h-4 w-4" />}
        </Button>
      );
    },
    cell: ({ row }) => (
      <div className="w-fit">
        <Badge
          className={cn(
            row.getValue('isActive')
              ? 'bg-green-50 text-success hover:bg-green-100 border-green-200'
              : 'bg-gray-50 text-text-primary hover:bg-gray-100 border-gray-200',
          )}
          variant={row.getValue('isActive') ? 'default' : 'secondary'}
        >
          {row.getValue('isActive') ? 'Active' : 'Inactive'}
        </Badge>
      </div>
    ),
  },
];
